import { render, staticRenderFns } from "./TabAttachFilesSystemDocument.vue?vue&type=template&id=f2a6740a&"
import script from "./TabAttachFilesSystemDocument.vue?vue&type=script&lang=js&"
export * from "./TabAttachFilesSystemDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports